var map = {
	"./number-1.svg": 724,
	"./number-2.svg": 725,
	"./number-3.svg": 726,
	"./number-4.svg": 727,
	"./number-5.svg": 728,
	"./number-6.svg": 729,
	"./number-7.svg": 730,
	"./number-8.svg": 731,
	"./number-9.svg": 732,
	"./number-shine-1.svg": 733,
	"./number-shine-2.svg": 734,
	"./number-shine-3.svg": 735,
	"./number-shine-4.svg": 736,
	"./number-shine-5.svg": 737,
	"./number-shine-6.svg": 738,
	"./number-shine-7.svg": 739,
	"./number-shine-8.svg": 740,
	"./number-shine-9.svg": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 723;